import {
    flattenAllCollectionsWithParents,
    iterateUp,
} from "./collection-methods";
import { type MappedProductCollectionModel } from "./models";

export function makeGroupedValue(
    id: number,
    existingValue: number[][] | undefined,
    viewMode: number,
    root: MappedProductCollectionModel[] | undefined | null
): { value: number[][]; scopedRootId?: number } {
    switch (viewMode) {
        case 0:
            return { value: [[id]] };
        case 1: {
            const result = existingValue?.concat() ?? [];
            const flatCollections = Array.from(
                flattenAllCollectionsWithParents(root)
            );
            const match = flatCollections.find(
                (col) => col.collection.Id == id
            );
            if (match == null)
                throw new Error(
                    "did not find a collection in root matching id " + id
                );
            const rootParent = Array.from(
                iterateUp(match.parents[match.parents.length - 1])
            ).find(
                (x) => x.parent?.FilterViewMode == viewMode || x.parent == null
            );

            if (rootParent == null) {
                return { value: [[id]] };
            }

            const matchedScopedRootItem = rootParent.parent;
            let scopedRootItem = matchedScopedRootItem;

            while (
                scopedRootItem != null &&
                scopedRootItem.FilterViewMode != 1 &&
                scopedRootItem.parent != null
            ) {
                scopedRootItem = scopedRootItem.parent;
            }

            const rootParentOwnerSet =
                matchedScopedRootItem?.SubCollections ?? root;

            const rootGroup = rootParentOwnerSet?.find(
                (x) => x.Id == rootParent.Id
            );

            if (rootGroup == null)
                throw new Error(
                    "did not find a parent in root matching id " + id
                );

            const rootPos = rootParentOwnerSet?.indexOf(rootGroup) ?? -1;

            // console.debug(
            //     "got rootPos: ",
            //     rootPos,
            //     rootGroup.Id,
            //     matchedScopedRootItem?.Id
            // );

            while (result.length < rootPos + 1) {
                result.push([]);
            }

            if (result[rootPos].indexOf(id) === -1) result[rootPos].push(id);

            for (const numberSet of result) {
                const removals = numberSet.filter((n) => {
                    const parent = flatCollections.find(
                        (x) => x.collection.Id == n
                    );
                    if (parent == null) throw new Error("Not found?");
                    return (
                        parent.collection.SubCollections.filter((x) =>
                            numberSet.includes(x.Id)
                        ).length > 1
                    );
                });
                for (const removal of removals) {
                    numberSet.splice(numberSet.indexOf(removal), 1);
                }

                // if (checked && depth != null && depth > 0) {
                //     const flatCol = Array.from(
                //         flattenAllCollectionsWithParents(
                //             props.scopedRoot?.SubCollections ??
                //                 ([] as MappedProductCollectionModel[])
                //         )
                //     );
                //     const col = flatCol.find((x) => x.collection.Id == collectionId);
                //     if (col != null) {
                //         const parent = col.parents[col.parents.length - 1];

                //         if (parent != null) {
                //             while (group.includes(parent.Id)) {
                //                 const index = group.indexOf(parent.Id);
                //                 group.splice(index, 1);
                //             }
                //         }
                //     }
                // }
            }

            return { value: result, scopedRootId: scopedRootItem?.Id };
        }
        default:
            throw new Error("Unknown viewMode: " + viewMode);
    }
}
